import { IUserService } from './../../_clean-code/services/contracts/user.service';
import * as c from './types';
import createApiAction from '../../api/createApiAction';
import createServiceAction from '../../_clean-code/services/stateManager/createServiceAction';
import { IMachinesGroupsService } from '../../_clean-code/services/contracts/machinesGroups.service';
import ServiceContext from '../../_clean-code/services/context/service.context';
import moment from 'moment-timezone';
import { I18n } from '../../utils/i18n';
import toastr from '../../utils/toastr';
import { IMachineService } from '_clean-code/services/contracts/machine-service';
import { SELECTED_COMPANY_ID } from '../../constants';
import { Logger } from '../../_clean-code/utils/logger';

export const getUserProfile = ({
  onSuccess = () => null,
  onError = () => null
}) =>
  createApiAction({
    method: 'getUserProfile',
    requestAction: c.GET_USER_PROFILE_REQUEST,
    successAction: c.GET_USER_PROFILE_SUCCESS,
    errorHandler(dispatch, { response }) {
      const errorMessage = response?.data?.error;

      dispatch({
        type: c.GET_USER_PROFILE_ERROR,
        payload: errorMessage
      });
      if (onError) onError();
    },
    transformResponse: ({ data }) => {
      moment.tz.setDefault(data.timezone); // TODO: coolgsus: look for a better place to put this;
      return data;
    },
    afterSuccess: (_dispatch) => {
      if (onSuccess) onSuccess();
    }
  });

export const selectMachineGroups = (machineGroups, selectedMachines) => ({
  type: c.SELECT_MACHINE_GROUPS,
  payload: { machineGroups, selectedMachines }
});

export const selectMachines = (machines) => ({
  type: c.SELECT_MACHINE_GROUP_MACHINES,
  payload: machines
});

export const getUserProfileData = () =>
  createServiceAction({
    doAction: c.GET_USER_PROFILE_DATA_REQUEST,
    successAction: c.GET_USER_PROFILE_DATA_SUCCESS,
    errorAction: c.GET_USER_PROFILE_DATA_ERROR,
    do: async () => {
      const mainDashboardService =
        ServiceContext.resolve<IMachinesGroupsService>('MachinesGroupsService');
      const userService = ServiceContext.resolve<IUserService>('UserService');
      const machineService =
        ServiceContext.resolve<IMachineService>('MachineService');
      const [userData, machinesGroups, machineResponse] = await Promise.all([
        userService.getCurrentUserData(),
        mainDashboardService.getUserMachinesGroups(),
        machineService.getMachines()
      ]);

      return {
        userData,
        machinesGroups,
        machines: machineResponse.data.machines
      };
    },
    errorHandler({ response }) {
      const error = response?.data.error;
      toastr.error(I18n.t('system_popup'), error);
    }
  });

export const getUserCompanies = (
  onSuccess?: (() => void) | undefined,
  onError?: (() => void) | undefined
) =>
  createServiceAction({
    doAction: c.GET_USER_COMPANIES_REQUEST,
    successAction: c.GET_USER_COMPANIES_SUCCESS,
    errorAction: c.GET_USER_COMPANIES_ERROR,
    do: async () => {
      const userService = ServiceContext.resolve<IUserService>('UserService');
      const companies = await userService.getUserCompanies();
      const companyId = companies?.[0]?.companyId;
      const previousCompanyId = localStorage.getItem(SELECTED_COMPANY_ID);
      // save companyId in storage if it's not already saved
      if (companyId && !previousCompanyId) {
        localStorage.setItem(SELECTED_COMPANY_ID, companyId.toString());
        Logger.debug('getUserCompanies: saving company ID', companyId);
      }
      onSuccess?.();
      return companies;
    },
    errorHandler(data) {
      const { response } = data;
      const error = response?.data.error;
      onError?.();
      toastr.error(I18n.t('system_popup'), error);
    }
  });
